import React from 'react';
import { Skeleton } from "@/components/ui/skeleton";

const DocumentSkeleton = ({ sections = 3 }) => {
  const getRandomWidth = () => {
    const widths = ['w-3/4', 'w-4/5', 'w-11/12', 'w-full'];
    return widths[Math.floor(Math.random() * widths.length)];
  };

  const getRandomParagraphCount = () => Math.floor(Math.random() * 3) + 1;

  const renderParagraph = () => {
    const lines = Math.floor(Math.random() * 4) + 2;
    return (
      <div className="space-y-2">
        {[...Array(lines)].map((_, i) => (
          <Skeleton key={i} className={`h-4 ${getRandomWidth()}`} />
        ))}
      </div>
    );
  };

  const renderSection = () => (
    <div className="space-y-4">
      <Skeleton className="h-8 w-4/5" />
      {[...Array(getRandomParagraphCount())].map((_, i) => (
        <div key={i}>{renderParagraph()}</div>
      ))}
    </div>
  );

  return (
    <div className="mx-8 space-y-8 p-6">
      <Skeleton className="h-12 w-3/4 mb-8" />
      <Skeleton className="h-6 w-1/3 mb-6" />
      {[...Array(sections)].map((_, i) => (
        <div key={i}>{renderSection()}</div>
      ))}
    </div>
  );
};

export default DocumentSkeleton;